import { useState, useEffect } from "react";
import BaseAppLayout from "../../layouts/BaseAppLayout/BaseAppLayout";
import { Toaster } from "react-hot-toast";
import ApiManager from "../../api/ApiManager";
import { useAuth } from "../../store/AuthContext/AuthContext";
import IndexComponent from "./IndexComponent";

export default function Index() {
  const [indexId, setIndexId] = useState(null);
  const [hasEnoughDocs, setHasEnoughDocs] = useState(false);
  const [loading, setLoading] = useState(true);
  const [aiResponse, setAiResponse] = useState(null);

  const { getCookie } = useAuth();
  const projectId = getCookie("project_id");
  const user_sub = getCookie("auth_token");
  const api = new ApiManager();

  // Initial load - check eligibility and get existing index
  useEffect(() => {
    checkEligibility();
  }, []);

  const checkEligibility = () => {
    setLoading(true);
    api
      .get(`/index/eligible?project_id=${projectId}`)
      .then((response) => {
        console.log("Risposta:", response.data);
        
        // Make sure we're properly extracting the index_id if it exists
        if (response.data.index && Array.isArray(response.data.index) && response.data.index.length > 0) {
          setIndexId(response.data.index[0].index_id);
        }
        
        // Explicitly log the eligible status
        console.log("Eligible status:", response.data.eligible);
        
        // Set the hasEnoughDocs state with the eligible status
        setHasEnoughDocs(Boolean(response.data.eligible));
        
        // Improved handling of the response to properly set aiResponse
        if (response.data.index && Array.isArray(response.data.index) && response.data.index.length > 0) {
          if (response.data.index[0].ai_response) {
            try {
              const jsonIndex = JSON.parse(response.data.index[0].ai_response);
              console.log("Parsed JSON index found:", jsonIndex);
              setAiResponse(jsonIndex.content || jsonIndex);
            } catch (e) {
              console.error("Error parsing JSON index:", e);
              setAiResponse(response.data.index[0].ai_response);
            }
          } else {
            console.log("Direct index found in response array:", response.data.index[0]);
            setAiResponse(response.data.index[0]);
          }
        } 
        else if (response.data.index && typeof response.data.index === 'object') {
          console.log("Index object found in response:", response.data.index);
          setAiResponse(response.data.index);
        }
        else if (response.data.ai_response) {
          console.log("Direct ai_response found:", response.data.ai_response);
          setAiResponse(response.data.ai_response);
        }
        
        setLoading(false);
      })
      .catch((error) => {
        console.error(
          "Errore durante la verifica della eligibilità all'indice:",
          error
        );
        setLoading(false);
        // Set to false in case of error
        setHasEnoughDocs(false);
      });
  };

  const handleGenerateIndex = async () => {
    setLoading(true);
    createIndex();
  };

  const createIndex = async () => {
    // These values would come from IndexComponent in the refactored version
    // This is just for maintaining the current functionality
    const selectedIndexLenght = 1; // Default value
    const selectedIndexStructure = 0; // Default value
    const hasSubsections = true; // Default value
    
    const lunghezza_indice = ["Essenziale", "Standard", "Approfondita", "Estesa"][selectedIndexLenght];
    const struttura = ["Classica", "Tematica", "Cronologica"][selectedIndexStructure];
    const sottosezioni = hasSubsections;

    api
      .post(
        "/index/create",
        {
          project_id: projectId,
          user_sub: user_sub,
          struttura: struttura,
          lunghezza_indice: lunghezza_indice,
          sottosezioni: sottosezioni,
        },
        { headers: { Authorization: `Bearer ${getCookie("id_token")}` } }
      )
      .then((response) => {
        console.log("Indice generato con successo:", response.data.statusCode);

        if (response.data.index) {
          setAiResponse(response.data.index);
        } else {
          setAiResponse(response.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Errore durante la generazione dell'indice:", error);
        setLoading(false);
      });
  };

  const handleGenerateNuovo = () => {
    setAiResponse(null);
    setLoading(false);
  };

  useEffect(() => {
   console.log(aiResponse)
  }, [IndexComponent]);

  console.log("Current hasEnoughDocs state before render:", hasEnoughDocs);

  return (
    <BaseAppLayout headerText="Libreria">
      <Toaster />
      <IndexComponent 
        hasEnoughDocs={hasEnoughDocs}
        loading={loading}
        aiResponse={aiResponse}
        setAiResponse={setAiResponse}
        handleGenerateIndex={handleGenerateIndex}
        handleGenerateNuovo={handleGenerateNuovo}
        checkEligibility={checkEligibility}
        createIndex={createIndex}
        projectId={projectId}
        user_sub={user_sub}
        getCookie={getCookie}
        api={api}
        indexId={indexId}
      />
    </BaseAppLayout>
  );
}